var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-683.000000, -996.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(176.000000, 954.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(0.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(411.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    transform: "translate(99.000000, 12.000000) rotate(-90.000000) translate(-99.000000, -12.000000) ",
    points: "95 10 99 14 103 10"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Right.888b81a831809e969cb8f07c3b16ae5a.svg";
export { ForwardRef as ReactComponent };